// src/utils/helpers/downloadReceipt.ts
//
// Simple fire-and-forget utility for downloading booking receipts.
// Uses fetch directly so the binary blob never touches Redux state.

const downloadReceipt = async (
  bookingId: number,
  bookingNumber: string
): Promise<void> => {
  const token   = localStorage.getItem("authToken");
  const baseUrl = process.env.REACT_APP_API_BASE_URL ?? "";

  const response = await fetch(
    `${baseUrl}/api/v1/bookings/${bookingId}/receipt`,
    {
      method: "GET",
      headers: {
        Accept: "application/pdf",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Receipt generation failed (${response.status})`);
  }

  const blob = await response.blob();
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `receipt-${bookingNumber}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export default downloadReceipt;